import React, {Component, useState} from 'react';

import {
    Dropdown,
    RadioButton,
} from "carbon-components-react";

export default class extends Component {

    state = {
        baseok: true,
        bases: ""
    };

    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {

    }


    async getBase(base, baseok,text) {
        this.props.onSubmitBase(base, baseok,text);
    }

    async setSelectBase(selectbase) {
        this.setState({baseok: selectbase});
        this.props.onSubmitSelectBase(selectbase);
    }

    render() {
        const {data, baseSelect, select, basetext} = this.props;

        // this.setState({baseok: select});
        let baseok = [];
        let basenok = [];
        let pOK = -1;
        let pnOk = -1;
        if (data.length > 0) {
            data.forEach(dados => {
                if (dados['collection_ok'] == true)
                    baseok.push({id: dados['collection_name'], text: dados['label_name']});
                else
                    basenok.push({id: dados['collection_name'], text: dados['label_name']});
            });
            //sku = this.removeDuplicates(sku, 'id');
        }
        pOK = baseok.findIndex(x => x.id === baseSelect);
        pnOk = basenok.findIndex(x => x.id === baseSelect);

        return (
            <div>
                <form onChange={this.handleChange}>
                    <div className="bx--row bx--row-no-ml">
                        <div className="bx--col-md-2">
                            <div className="bx--row">
                                <RadioButton
                                    id="radio-x"
                                    labelText="Base Ok"
                                    checked={select}
                                    value="baseko"
                                    name="ckbaseok"
                                    onClick={(evt) => {
                                        this.setSelectBase(true);
                                    }}
                                />
                            </div>
                            <div className="bx--row combo-base bx--col-md-8">
                                <Dropdown
                                    useTitleInItem={false}
                                    disabled={!select}
                                    id="baseok"
                                    name="baseok"
                                    label="Select Base"
                                    placeholder="Selecione base ok disponível"
                                    invalid={false}
                                    invalidText="Invalid Selection"
                                    items={baseok}
                                    initialSelectedItem={baseok[pOK]}
                                    selectedItem={baseok[pOK]}
                                    itemToString={(item) => (item ? item.text : '')}
                                    onChange={(evt) => {
                                        this.getBase(evt.selectedItem.id, true,evt.selectedItem.text);
                                    }}
                                />
                            </div>
                        </div>
                        <div className="bx--col-md-2">
                            <div className="bx--row">
                                <RadioButton
                                    id="radio-y"
                                    labelText="Base NOK"
                                    value="ckbasenok"
                                    name="ckbaseok"
                                    checked={!select}
                                    onClick={(evt) => {
                                        this.setSelectBase(false);
                                    }}
                                />
                            </div>
                            <div className="bx--row combo-base bx--col-md-8">
                                <div className="bx--col-lg-16">
                                    <Dropdown
                                        useTitleInItem={false}
                                        disabled={select}
                                        id="basenok"
                                        name="basenok"
                                        label="Select Base"
                                        placeholder="Selecione base NOK disponível"
                                        invalid={false}
                                        invalidText="Invalid Selection"
                                        items={basenok}
                                        selectedItem={basenok[pnOk]}
                                        selectedItem={basenok[pnOk]}
                                        itemToString={(item) => (item ? item.text : '')}
                                        onChange={(evt) => {
                                            this.getBase(evt.selectedItem.id, false,evt.selectedItem.text);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}
